import { DailyTotals } from '@/types'

function toNumber(value: unknown): number {
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0
  if (typeof value === 'string') {
    const normalized = value.replace(/\u00A0/g, ' ').replace(/\s/g, '').replace(',', '.')
    const parsed = Number(normalized)
    return Number.isFinite(parsed) ? parsed : 0
  }
  return 0
}

export function calculateGrossRevenueFromDaily(metrics: Partial<DailyTotals> | null | undefined): number {
  if (!metrics) return 0

  const revenueComponents = [
    metrics.new_sales_amount,
    metrics.trial_payments_amount,
    metrics.renewals_amount,
    metrics.upgrades_amount,
    metrics.returning_clients_amount,
    metrics.private_sessions_amount,
    metrics.other_income,
    metrics.membership_fees_new_amount,
    metrics.new_subscriptions_amount,
    metrics.membership_fees_subscription_upgrades_amount,
    metrics.membership_fees_subscription_returning_amount,
    metrics.subscription_renewals_amount,
    metrics.subscription_upgrades_amount,
    metrics.subscription_returning_clients_amount
  ]

  const totalRevenue = revenueComponents.reduce((sum, value) => sum + toNumber(value), 0)
  const refunds = toNumber(metrics.refunds_amount) // Возвраты хранятся со знаком, обычно отрицательные.
  const calculated = totalRevenue + refunds

  // Legacy fallback: historical rows could have only gross_revenue filled manually.
  // Until those rows are backfilled to components, preserve historical gross value.
  const persistedGrossRevenue = toNumber(metrics.gross_revenue)
  const hasAnyRevenueComponent = revenueComponents.some((value) => toNumber(value) !== 0) || refunds !== 0
  if (!hasAnyRevenueComponent && persistedGrossRevenue !== 0) {
    return persistedGrossRevenue
  }

  return calculated
}
